import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
export const StyledContainer = styled.div `
  display: flex;
`;
export const StyledStarRating = styled.ul `
  display: inline-flex;
  align-items: center;
`;
export const StyledStar = styled.li `
  display: flex;
  align-items: center;
  margin-left: ${pxToRems(2)};
  &:first-child {
    margin-left: 0;
  }

  ${({ size }) => {
    const iconWidths = {
        small: '12px',
        medium: '16px',
    };
    const sizeIsArray = Array.isArray(size);
    return css `
      ${sizeIsArray
        ? css `
            & > svg {
              width: ${iconWidths[size[0]]};

              @media screen and (min-width: ${breakpoints[0]}px) {
                width: ${iconWidths[size[1]]};
              }

              @media screen and (min-width: ${breakpoints[1]}px) {
                width: ${iconWidths[size[2]]};
              }

              @media screen and (min-width: ${breakpoints[2]}px) {
                width: ${iconWidths[size[3]]};
              }
            }
          `
        : css `
            & > svg {
              width: ${iconWidths[size]};
            }
          `}
    `;
}}
`;
export const StyledDescription = styled.div `
  font-size: ${({ size }) => pxToRems(size === 'small' ? '12' : '16')};
  line-height: ${({ size }) => pxToRems(size === 'small' ? '14' : '20')};
  margin-left: ${pxToRems(8)};
`;
//# sourceMappingURL=grade.styles.js.map